import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      input: this.el.querySelector('input')
    };

    this.getInputValue();
  }

  addListeners() {
    this.dom.input.addEventListener('change', () => this.getInputValue());
  }

  getInputValue() {
    const { value } = this.dom.input;

    this.el.classList.toggle('field--filled', value);
  }
}

export default Module;
